(function () {
  'use strict';

  var key = 'polymaker.formnext2026.source.v1';
  var source = 'formnext2026';
  var lifetime = 24 * 60 * 60 * 1000;
  var memory = null;
  var memoryOnly = false;
  var storage;

  try {
    storage = window.sessionStorage;
  } catch (error) {
    memoryOnly = true;
  }

  function valid(context) {
    var now = Date.now();
    return context && context.version === 1 && context.source === source &&
      Number.isFinite(context.capturedAt) && context.capturedAt <= now &&
      context.expiresAt === context.capturedAt + lifetime && now < context.expiresAt;
  }

  function contextId() {
    try {
      if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    } catch (error) {}
    return Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  }

  function clear() {
    memory = null;
    try {
      storage.removeItem(key);
      memoryOnly = false;
    } catch (error) {
      memoryOnly = true;
      try {
        storage.setItem(key, '');
        memoryOnly = false;
      } catch (ignored) {}
    }
  }

  function current() {
    var context = memory;
    if (!memoryOnly) {
      try {
        var saved = storage.getItem(key);
        context = saved ? JSON.parse(saved) : null;
        // Persisted attribution is usable only while it can also be invalidated.
        if (valid(context)) {
          if (typeof context.id !== 'string' || !context.id) context.id = contextId();
          storage.setItem(key, JSON.stringify(context));
        }
      } catch (error) {
        if (error instanceof SyntaxError) {
          clear();
          return null;
        }
        memoryOnly = true;
        context = memory;
      }
    }
    if (!valid(context)) {
      clear();
      return null;
    }
    return context;
  }

  function capture() {
    var values = new URLSearchParams(window.location.search).getAll('source');
    if (values.length === 0 || (values.length === 1 && values[0] === '')) {
      current();
      return;
    }
    if (values.length !== 1 || values[0] !== source) {
      clear();
      return;
    }
    var now = Date.now();
    memory = { version: 1, id: contextId(), source: source, capturedAt: now, expiresAt: now + lifetime };
    try {
      storage.setItem(key, JSON.stringify(memory));
      memoryOnly = false;
    } catch (error) {
      memoryOnly = true;
    }
  }

  function getSource() {
    return current() ? 'formnext-2026' : null;
  }

  function getExpiresAt() {
    var context = current();
    return context ? context.expiresAt : null;
  }

  function getContextId() {
    var context = current();
    return context ? context.id : null;
  }

  function completeRegistration() {
    clear();
    // Avoid re-capturing this already-consumed QR source when this page reloads.
    try {
      var url = new URL(window.location.href);
      var values = url.searchParams.getAll('source');
      if (values.length === 1 && values[0] === source) {
        url.searchParams.delete('source');
        window.history.replaceState(window.history.state, '', url.href);
      }
    } catch (error) {}
  }

  capture();
  window.PolymakerFormnext = {
    getSource: getSource,
    getExpiresAt: getExpiresAt,
    getContextId: getContextId,
    completeRegistration: completeRegistration
  };
  // Document-local fallback must not survive navigation into an older history entry.
  window.addEventListener('pagehide', function () { memory = null; });
  window.addEventListener('pageshow', getSource);
})();
